module.exports = __webpack_public_path__ + "static/media/berkeley 1.fb2ec69e.png";